import {createReducer, on} from '@ngrx/store';
import {
  fetchTopBanners,
  fetchTopBannersSuccess,
  fetchTopBannersFailure,
  fetchLastUpdates,
  fetchLastUpdatesSuccess,
  fetchLastUpdatesFailure, fetchGroupDetails, fetchGroupDetailsSuccess, fetchGroupDetailsFailure
} from './dashboard.actions';

import {IDashboardState, IState} from '@models/index';

const initialState: IDashboardState = {
  data: {},
};

const _dashboardReducer = createReducer(
  initialState,
  on(fetchTopBanners, (state) => {
    return state;
  }),
  on(fetchTopBannersSuccess, (state, {topBanner}) => {
    const payload = {
      data: Object.assign(state.data, {topBanner}),
    };

    return {...state, ...payload};
  }),
  on(fetchTopBannersFailure, (state, {error}) => {
    const payload = {
      isLoaded: true,
      error
    };
    return {...state, ...payload};
  }),
  on(fetchLastUpdates, (state) => {
    const returnState = {
      data: Object.assign(state.data, {
        lastUpdates: {
          isLoaded: false,
          isLoading: true,
          data: [],
          error: null
        }
      }),
    };

    return {...state, ...returnState};
  }),
  on(fetchLastUpdatesSuccess, (state, {payload}) => {
    const returnState = {
      data: Object.assign(state.data, {
        lastUpdates: {
          isLoaded: true,
          isLoading: false,
          data: payload,
          error: null
        }
      }),
    };

    return {...state, ...returnState};
  }),
  on(fetchLastUpdatesFailure, (state, {error}) => {
    const returnState = {
      error,
      data: Object.assign(state.data, {
        lastUpdates: {
          isLoaded: true,
          isLoading: false,
          data: [],
          error
        }
      }),
    };

    return {...state, ...returnState};
  }),
  on(fetchGroupDetails, (state) => {
    const returnState = {
      data: Object.assign(state.data, {
        groupDetails: {
          isLoaded: false,
          isLoading: true,
          data: [],
          error: null
        }
      }),
    };

    return {...state, ...returnState};
  }),
  on(fetchGroupDetailsSuccess, (state, {payload}) => {
    const returnState = {
      data: Object.assign(state.data, {
        groupDetails: {
          isLoaded: true,
          isLoading: false,
          data: payload,
          error: null
        }
      }),
    };

    return {...state, ...returnState};
  }),
  on(fetchGroupDetailsFailure, (state, {error}) => {
    const payload = {
      error,
      data: Object.assign(state.data, {
        groupDetails: {
          isLoaded: true,
          isLoading: false,
          data: [],
          error
        }
      })
    };
    return {...state, ...payload};
  }),
);

export function dashboardReducer(state, action) {
  return _dashboardReducer(state, action);
}
